module.exports = require("core-js/modules/es7.object.get-own-property-descriptors");